import React from "react";
import styled from "styled-components";

const StyledDeadlineBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(props) => props.theme.space[2]};
  border-bottom: ${(props) => props.theme.borders[2]};
  font-size: ${(props) => props.theme.fontSizes[3]};

  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    padding: ${({ theme }) =>
      `0 ${theme.space[2]} ${theme.space[2]} ${theme.space[2]}`};
  }
`;

const Heading = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.fontSizes[3]};
  text-transform: capitalize;

  @media (min-width: ${(props) => props.theme.breakpoints[0]}) {
    font-size: 2rem;
  }
`;

const Deadline = styled.time`
  margin-left: ${(props) => props.theme.space[4]};
  font-weight: bold;
`;

interface IProps {
  /**
   * Local ISO formatted deadline time
   */
  deadlineISO: string;
  /**
   * Human-friendly local deadline time
   */
  deadlineLocal: string;
  /**
   * Deadline heading
   */
  headingText: string;
}

const DeadlineBar: React.FC<IProps> = ({
  deadlineISO,
  deadlineLocal,
  headingText,
}) => (
  <StyledDeadlineBar>
    <Heading>{headingText}:</Heading>
    <span>&nbsp;</span>
    <Deadline dateTime={deadlineISO}>{deadlineLocal}</Deadline>
  </StyledDeadlineBar>
);

export default DeadlineBar;
